module.exports = __webpack_public_path__ + "f8d9722d181619be8bfd649d7cfcb72f.jpg";